import { render, staticRenderFns } from "./Postos.vue?vue&type=template&id=e1501414&scoped=true&"
import script from "./Postos.vue?vue&type=script&lang=js&"
export * from "./Postos.vue?vue&type=script&lang=js&"
import style0 from "./Postos.vue?vue&type=style&index=0&id=e1501414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1501414",
  null
  
)

export default component.exports